import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import { getActiveClientsRequest } from "../requests/accessControl";
import { ACCESS_CONTROL_QUERY_KEYS } from "../../query/keys";

export const useActiveClients = (
  page = 1,
  options?: { enabled?: boolean; date?: string },
) => {
  const { token } = useAuth();

  const { data, isLoading, error } = useQuery({
    queryKey: ACCESS_CONTROL_QUERY_KEYS.activeClients(page, options?.date),
    queryFn: () => getActiveClientsRequest(token!, page, options?.date),
    enabled: Boolean(token) && (options?.enabled ?? true),
    placeholderData: keepPreviousData,
    refetchInterval: 30_000,
    staleTime: 15_000,
    refetchOnMount: true,
  });

  return {
    clients: data?.clients ?? [],
    total: data?.total ?? 0,
    limit: data?.limit ?? 10,
    isLoading,
    error,
  };
};
